export default __webpack_public_path__ + "static/media/4th.215a09af.png";